import type { TaskForAsyncTaskFunction } from 'ember-concurrency';
import PowerCalendarDays, {
  type PowerCalendarDaysArgs,
} from 'ember-power-calendar/components/power-calendar/days';
import { or } from 'ember-truth-helpers';
import MarketSmartInsightsCalendarDaySmartInsights from 'lumen/components/market/smart-insights/calendar/day-smart-insights';
import emberPowerCalendarDayClassesCustom from 'lumen/helpers/ember-power-calendar-day-classes-custom';
import type { SmartInsightDay } from 'lumen/models';

interface MarketSmartInsightsCalendarDaysSmartInsightsArgs extends PowerCalendarDaysArgs {
  insightCountsByStayDate: Record<string, number>;
  insightsByStayDate: Record<string, SmartInsightDay[]>;
  maxInsightEntriesPerDay: number;
  priority: number;
  selectSmartInsightsDay: (stayDate: string) => void;
  tooltipHoverTrackingTask: TaskForAsyncTaskFunction<
    {
      restartable: boolean;
    },
    (insight: SmartInsightDay) => Promise<void>
  >;
}

export default class MarketSmartInsightsCalendarDaysSmartInsights extends PowerCalendarDays {
  declare args: MarketSmartInsightsCalendarDaysSmartInsightsArgs;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get weeks() {
    const { showDaysAround, days } = this;

    const weeks = [];
    let i = 0;
    while (days[i]) {
      let daysOfWeek = days.slice(i, i + 7);
      if (!showDaysAround) {
        daysOfWeek = daysOfWeek.filter((d) => d.isCurrentMonth);
      }

      const firstDay = daysOfWeek[0];

      if (!firstDay) {
        break;
      }

      weeks.push({
        id: `week-of-${firstDay.id}`,
        days: daysOfWeek,
        missingDays: 7 - daysOfWeek.length,
      });
      i += 7;
    }

    return weeks;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getDayFirstLetter(dayName: string) {
    return dayName.charAt(0);
  }

  <template>
    <div
      class="ember-power-calendar-days"
      data-power-calendar-id={{or
        @calendar.calendarUniqueId
        @calendar.uniqueId
      }}
      ...attributes
    >
      <div class="ember-power-calendar-row ember-power-calendar-weekdays">
        {{#each this.weekdaysNames as |wdn|}}
          <div class="ember-power-calendar-weekday">
            {{wdn}}
          </div>
        {{/each}}
      </div>
      <div class="ember-power-calendar-day-grid">
        {{#each this.weeks key="id" as |week|}}
          <div
            class="ember-power-calendar-row ember-power-calendar-week"
            data-missing-days={{week.missingDays}}
          >
            {{#each week.days key="id" as |day|}}
              <MarketSmartInsightsCalendarDaySmartInsights
                @day={{day}}
                @dayClass={{emberPowerCalendarDayClassesCustom
                  day
                  @calendar
                  this.weeks
                  @dayClass
                }}
                {{! @glint-expect-error: Incorrect type }}
                @insightCountsByStayDate={{@insightCountsByStayDate}}
                {{! @glint-expect-error: Incorrect type }}
                @insightsByStayDate={{@insightsByStayDate}}
                {{! @glint-expect-error: Incorrect type }}
                @maxInsightEntriesPerDay={{@maxInsightEntriesPerDay}}
                {{! @glint-expect-error: Incorrect type }}
                @selectSmartInsightsDay={{@selectSmartInsightsDay}}
              />
            {{/each}}
          </div>
        {{/each}}
      </div>
    </div>
  </template>
}
